import image7 from "./spark7.svg"
import image6 from "./spark6.svg"
import image5 from "./spark5.svg"
import image4 from "./spark4.svg"
import image3 from "./spark3.svg"
import image2 from "./spark2.svg"
import image1 from "./spark1.svg"
// The sparklines are displayed on the trending page. We have to use our own images because the images from the API had CORS issues.


const SPARKS: string[] = [
    image1,
    image2,
    image3,
    image4,
    image7,
    image6,
    image5
]

export default SPARKS
